export const thumb = img => img.formats.small?.url || img.url
